module.exports = __webpack_public_path__ + "static/img/xiajiang.23a15f3d.svg";